const objToFormData = (object) => {
    let formData = new FormData();

    for (const property in object) {
        let value = object[property];

        if (!value) {
            continue;
        }

        if (typeof value === 'boolean') {
            value = value ? 1 : 0;
        }

        if (Array.isArray(value)){
            formData = arrayHandler(formData, property, value);
            continue;
        }

        if (value instanceof FileList) {
            formData = fileListHandler(formData, property, value);
            continue;
        }
        
        formData.append(`${property}`, value);
    }

    return formData;
};

const arrayHandler = (formData, property, value) => {
    value.forEach((item, index) => {
        for (const itemProperty in item) {
            const value = item[itemProperty];
            formData.append(`${property}[${index}][${itemProperty}]`, value);
        }
    });

    return formData;
};

const fileListHandler = (formData, property, fileList) => {
    for (var i = 0; i < fileList.length; i++) {
        const file = fileList.item(i);
        formData.append(`${property}[${i}]`, file);
    };

    return formData;
};

export default objToFormData;
